module.exports = __webpack_public_path__ + "static/media/icon_mensalista.1a8d6c81.svg";